import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'storageUrlUnsanitized'
})
export class StorageUrlUnsanitizedPipe implements PipeTransform {

  private storageURL!: string;

  constructor(
  ) {
    this.storageURL = environment.apiConfig.storageURL;
  }

  transform(value?: string) {
    return value ?  (this.storageURL + value) : '';
  }

}
